var exports = {
  "Q": "ChannelDuplicateModal.module__content___WFlEYV",
  "c": "ChannelDuplicateModal.module__helperText___WFlEYV",
};

module.exports = exports;
